import React from 'react'
import axios from 'axios'

const AdminTestIndex = () => {
  const handleUpdateBoxNo = async () => {
    try {
      const response = await axios.post('/api/v1/admin/test/update-boxnos')
      alert(response.data.message)
    } catch (error) {
      console.error('Update error:', error)
      alert('Failed to update box numbers')
    }
  }

  return (
    <div>
      <h1>AdminTestIndex</h1>
      <button onClick={handleUpdateBoxNo}>Fix "empty" Box Numbers</button>
    </div>
  )
}

export default AdminTestIndex
